import { iframeCommunication, MESSAGE_TYPES } from './iframe-communication';
import { userState } from './user-state';
export function initializeIframe() {
    const exploreLink = document.getElementById('explore-link');
    const tryNowLink = document.getElementById('try-now-link');
    const headerLogo = document.querySelector('header a[href="#"]');
    const mainContent = document.getElementById('main-content');
    const iframeContainer = document.getElementById('iframe-container');
    const footer = document.querySelector('footer');
    const iframe = document.getElementById('playground-iframe');
    console.log('Initializing iframe functionality...', {
        exploreLink: !!exploreLink,
        tryNowLink: !!tryNowLink,
        headerLogo: !!headerLogo,
        mainContent: !!mainContent,
        iframeContainer: !!iframeContainer,
        footer: !!footer,
        iframe: !!iframe
    });
    if (!exploreLink || !tryNowLink || !headerLogo || !mainContent || !iframeContainer || !iframe) {
        console.error('Required elements not found for iframe functionality');
        return;
    }
    // Set iframe src dynamically based on hostname
    const isLocalhost = window.location.hostname.includes('localhost');
    const iframeSrc = isLocalhost ? 'http://localhost:7777' : 'https://playground.numeriquai.com';
    iframe.src = iframeSrc;
    console.log('Iframe src set to:', iframeSrc);
    // Initialize iframe communication
    iframeCommunication.initialize(iframe);
    // Set up message handlers
    setupIframeMessageHandlers();
    // Show iframe when Explore is clicked
    exploreLink.addEventListener('click', (e) => {
        e.preventDefault();
        mainContent.classList.add('hidden');
        iframeContainer.classList.remove('hidden');
        if (footer)
            footer.classList.add('hidden');
    });
    // Show iframe when Try now! is clicked
    tryNowLink.addEventListener('click', (e) => {
        e.preventDefault();
        mainContent.classList.add('hidden');
        iframeContainer.classList.remove('hidden');
        if (footer)
            footer.classList.add('hidden');
    });
    // Return to main site when header logo is clicked
    headerLogo.addEventListener('click', (e) => {
        e.preventDefault();
        mainContent.classList.remove('hidden');
        iframeContainer.classList.add('hidden');
        if (footer)
            footer.classList.remove('hidden');
    });
}
function setupIframeMessageHandlers() {
    console.log('[iframe] Setting up message handlers');
    // Handle initial auth status
    iframeCommunication.onMessage(MESSAGE_TYPES.APP_AUTH_STATUS, (data) => {
        console.log('[iframe] Received auth status:', data);
        if (data && typeof data.isAuthenticated === 'boolean') {
            if (data.isAuthenticated && data.user) {
                userState.setUser(data.user);
            }
            else {
                userState.clearUser();
            }
        }
    });
    // Handle login success
    iframeCommunication.onMessage(MESSAGE_TYPES.APP_LOGIN_SUCCESS, (data) => {
        console.log('[iframe] User logged in successfully:', data);
        if (data && data.user) {
            userState.setUser(data.user);
        }
    });
    // Handle login error
    iframeCommunication.onMessage(MESSAGE_TYPES.APP_LOGIN_ERROR, (data) => {
        console.log('[iframe] Login error:', data);
        userState.clearUser();
    });
    // Handle logout success
    iframeCommunication.onMessage(MESSAGE_TYPES.APP_LOGOUT_SUCCESS, () => {
        console.log('[iframe] User logged out successfully');
        userState.clearUser();
    });
    // Handle logout error
    iframeCommunication.onMessage(MESSAGE_TYPES.APP_LOGOUT_ERROR, (data) => {
        console.log('[iframe] Logout error:', data);
        // Don't clear user state on logout error
    });
    console.log('[iframe] Message handlers set up');
}
